module.exports = __webpack_public_path__ + "static/Riley-177-fda1e548ce54498d3ac720efc32426cb.jpg";